import { Box, Typography } from "@mui/material";

const RenderFileDetail = ({
  label,
  shownDetail,
}: {
  label: String;
  shownDetail: string;
}): React.JSX.Element => (
  <Box>
    <Typography variant="caption" component="p" color={"text.primary"}>
      {`${label}:`}
    </Typography>
    <Typography
      variant="body2"
      component="p"
      color={"text.primary"}
      sx={{
        wordBreak: "break-all",
      }}
    >
      {shownDetail}
    </Typography>
  </Box>
);

export default RenderFileDetail;
